"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageOne = void 0;
var _core = require("@dragon/core");
var _pixi = require("pixi.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _superPropGet(t, e, r, o) { var p = _get(_getPrototypeOf(1 & o ? t.prototype : t), e, r); return 2 & o ? function (t) { return p.apply(r, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PageOne = exports.PageOne = /*#__PURE__*/function (_Container) {
  function PageOne(styleMap, locale) {
    var _this;
    _classCallCheck(this, PageOne);
    _this = _callSuper(this, PageOne);
    _defineProperty(_this, "destroy", function () {
      _superPropGet((_this, PageOne), "destroy", _this, 3)([]);
    });
    _this.name = "Page1";
    var header = new _pixi.Text(_core.CORE.translate("bsplP1Header"), styleMap.header);
    header.anchor.set(0.5);
    header.x = 0;
    header.y = -230;
    _this.addChild(header);
    var subHeader = new _pixi.Text(_core.CORE.translate("bsplP1SubHeader"), styleMap.subHeader);
    subHeader.anchor.set(0.5);
    subHeader.x = 0;
    subHeader.y = -186;
    _this.addChild(subHeader);
    var one = new _pixi.Sprite(_pixi.Texture.from("bspl_i1.png"));
    var two = new _pixi.Sprite(_pixi.Texture.from("bspl_i2.png"));
    var three = new _pixi.Sprite(_pixi.Texture.from("bspl_i3.png"));
    one.anchor.set(0.5);
    two.anchor.set(0.5);
    three.anchor.set(0.5);
    one.y = two.y = three.y = -90;
    one.x = -300;
    three.x = 300;
    _this.addChild(one, two, three);

    //details
    var det1 = new _pixi.Text(_core.CORE.translate("bsplP1det1"), styleMap.detail);
    det1.anchor.set(0.5, 0);
    det1.x = -300;
    det1.y = -30;
    _this.addChild(det1);
    var det2 = new _pixi.Text(_core.CORE.translate("bsplP1det2"), styleMap.detail);
    det2.anchor.set(0.5, 0);
    det2.x = 0;
    det2.y = -30;
    _this.addChild(det2);
    var det3 = new _pixi.Text(_core.CORE.translate("bsplP1det3"), styleMap.detail);
    det3.anchor.set(0.5, 0);
    det3.x = 300;
    det3.y = -30;
    _this.addChild(det3);
    var warnText = new _pixi.Text(_core.CORE.translate("bsplP1warn"), styleMap.subHeader);
    warnText.anchor.set(0.5, 0);
    warnText.x = 0;
    warnText.y = 80;
    var warning1 = new _pixi.Sprite(_pixi.Texture.from("bspl_triangle.png"));
    var warning2 = new _pixi.Sprite(_pixi.Texture.from("bspl_triangle.png"));
    warning1.anchor.set(0.5);
    warning2.anchor.set(0.5);
    warning1.y = warning2.y = 100;
    warning1.x = warnText.width / 2 + 40;
    warning2.x = -(warnText.width / 2 + 40);
    _this.addChild(warnText, warning1, warning2);
    return _this;
  }
  _inherits(PageOne, _Container);
  return _createClass(PageOne);
}(_pixi.Container);
//# sourceMappingURL=PageOne.js.map